// =============================================================
// ☁️ KeywordsCloud.jsx — Nuvem de palavras das mensagens recentes
// =============================================================

import React, { useEffect, useState } from "react";
import { listenAllMessages } from "../../../services/iaDashboard/messagesService";
import { extractKeywords } from "../../../services/iaDashboard/insightsService";

export default function KeywordsCloud() {
  const [keywords, setKeywords] = useState([]);

  useEffect(() => {
    const unsub = listenAllMessages((messages) => {
      setKeywords(extractKeywords(messages || []));
    });

    return () => unsub && unsub();
  }, []);

  if (!keywords.length)
    return <div className="ia-chart-empty">Gerando nuvem de palavras...</div>;

  return (
    <div className="ia-insight-card">
      <div className="ia-insight-title">Palavras mais citadas</div>

      <div style={{ lineHeight: "26px" }}>
        {keywords.map((k, index) => (
          <span
            key={index}
            style={{
              fontSize: `${12 + k.weight * 0.4}px`,
              marginRight: 10,
              color: "#d81b60",
              display: "inline-block",
            }}
          >
            {k.word}
          </span>
        ))}
      </div>
    </div>
  );
}
